import React, {useRef} from 'react';
import {UseLoader} from "../../../hooks/useLoader";
import {useForm} from "react-hook-form";
import {Toast} from "primereact/toast";
import {Dialog} from "primereact/dialog";
import {ContainerForm} from "../../../components/Containers/ContainerForm";
import {ContainerGroupForm} from "../../../components/Containers/ContainerGroupForm";

import {guardarCliente} from "../../../api/cliente.service";
import PropTypes from "prop-types";
import { confirmDialog } from 'primereact/confirmdialog';


export const ModalNuevoCliente = ({show, hide}) => {
    const [handleLoader] = UseLoader();
    const toast = useRef(null);

    const {register, handleSubmit, formState: {errors}} = useForm();

    const onSubmit = payload => {
        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () =>  {
                    handleLoader(true);
                    const response = await guardarCliente(payload);
                    const data = await response.data;
                    handleLoader(false)
                    if (data.estado !== 200) {
                        toast.current?.show({severity:'error', summary: 'Alerta', detail: data.mensaje, life: 3000});
                        return;
                    }

                    toast.current?.show({severity:'success', summary: 'Exito', detail: data.mensaje, life: 3000});
                    hide()
                }
            });

        }catch (e) {
            handleLoader(false)
            console.log(e)
        }
    }

    return (
        <>
            <Toast ref={toast}/>
            <Dialog modal maximizable header="Crear nuevo cliente" visible={show} style={{width: '90vw'}}
                     onHide={hide}>
                <div className="md:px-4">
                    <ContainerForm>
                        <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                            <h6 className="title-modal">
                                Información Cliente
                            </h6>

                            <div className="row">
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="nombre"
                                    >
                                        Nombre *
                                    </label>
                                    <input
                                        {...register("nombre", {required: true, maxLength: 150 })}
                                        id="nombre"
                                        type="text"
                                        className="form-input-small uppercase"
                                    />
                                    {errors.nombre?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.nombre?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 150 caracteres</span>}

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="nit"
                                    >
                                        Nit *
                                    </label>
                                    <input
                                        {...register("nit", {required: true, maxLength: 11, valueAsNumber: true })}
                                        id="nit"
                                        type="number"
                                        className="form-input-small"
                                    />
                                    {errors.nit?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                    {errors.nit?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 11 caracteres</span>}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="centro_costo"
                                    >
                                        Centro de costos *
                                    </label>
                                    <input
                                        {...register("centro_costo", {required: true, maxLength: 5 })}
                                        id="centro_costo"
                                        type="text"
                                        className="form-input-small"
                                    />

                                    {errors.centro_costo?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 5 caracteres</span>}
                                    {errors.centro_costo?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="facturacion"
                                    >
                                        Tipo de facturación *
                                    </label>
                                    <select
                                        {...register("facturacion", {required: true })}
                                        className="form-input-small"
                                        id="facturacion">
                                        <option value="">seleccione</option>
                                        <option value="E">Evento</option>
                                        <option value="H">Hora</option>
                                    </select>
                                    {errors.facturacion?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="telefono"
                                    >
                                        telefono
                                    </label>
                                    <input
                                        {...register("telefono", {maxLength: 30 })}
                                        id="telefono"
                                        type="text"
                                        className="form-input-small"
                                    />

                                    {errors.telefono?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 30 caracteres</span>}

                                </ContainerGroupForm>

                                <ContainerGroupForm width="lg:w-4/12">
                                    <label
                                        className="label-form"
                                        htmlFor="estado"
                                    >
                                        Estado
                                    </label>
                                    <select
                                        {...register("estado", {required: true })}
                                        className="form-input-small"
                                        id="estado">
                                        <option value="">seleccione</option>
                                        <option value="A">Activo</option>
                                        <option value="I">Inactivo</option>
                                    </select>
                                    {errors.estado?.type === 'required' && <span className="text-red-600 font-bold text-xs">El campo es obligatorio</span>}
                                </ContainerGroupForm>
                            </div>

                            <ContainerGroupForm width="lg:w-6/12">
                                <label
                                    className="label-form"
                                    htmlFor="direccion"
                                >
                                    Direccion
                                </label>
                                <input
                                    {...register("direccion", {maxLength: 250 })}
                                    id="direccion"
                                    type="text"
                                    className="form-input-small"
                                />

                                {errors.direccion?.type === 'maxLength' && <span className="text-red-600 font-bold text-xs">El campo solo permite máximo 250 caracteres</span>}

                            </ContainerGroupForm>

                            <hr className="mt-6 border-b-1 border-blueGray-300"/>
                            <div className="row mt-4">
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="primary-color-btn btn w-full"
                                        type="submit"
                                    >
                                        Guardar
                                    </button>

                                </ContainerGroupForm>
                                <ContainerGroupForm width="lg:w-2/12">
                                    <button
                                        className="danger-color-btn btn w-full"
                                        type="button"
                                        onClick={hide}
                                    >
                                        Cerrar
                                    </button>

                                </ContainerGroupForm>
                            </div>
                        </form>
                    </ContainerForm>
                </div>

            </Dialog>
        </>
    );
};

ModalNuevoCliente.prototype = {
    show: PropTypes.bool,
    hide: PropTypes.func
}

ModalNuevoCliente.defaultProps = {
    show: false,
};



